$(document).ready(function(){

	// -- Background Video -- 
	if ($('video').length) {
	
		var vid = document.getElementById("bgvid");
		var pauseButton = document.getElementById("vidpause");

		vid.addEventListener('ended', function() {
		  // only functional if "loop" is removed
		  vid.pause();
		  // to capture IE10
		  vidFade();
		});

		pauseButton.addEventListener("click", function() {
		  if (vid.paused) {
		    vid.play();
			  $('#vidpause .icon').removeClass('play').addClass('pause');
			  $('#bgvid').removeClass('fade');
		  } else {
		    vid.pause();
			  $('#vidpause .icon').removeClass('pause').addClass('play');
			  $('#bgvid').addClass('fade');
		  }
		});
	}

});